import { Controller, useForm } from 'react-hook-form';
import { useId } from 'react';

import { Label } from '../../../../../../../../components/Toolkit/Inputs/Label';
import { Button } from '../../../../../../../../components/Toolkit/Button/Button';
import { RegistrationNumberField } from '../../../../../../../../components/Toolkit/Inputs/RegistrationNumberField';

import * as Styled from './VehicleRegistrationLookupForm.styled';

type VehicleRegistrationLookupFormProps = {
  onSubmitCallback: (value: string) => void;
  initialRegistrationNumber: string;
};

type FormInputs = {
  registrationNumber: string;
};

const VehicleRegistrationLookupForm = (
  props: VehicleRegistrationLookupFormProps,
) => {
  const { onSubmitCallback, initialRegistrationNumber } = props;

  const { control, handleSubmit } = useForm<FormInputs>({
    defaultValues: {
      registrationNumber: initialRegistrationNumber,
    },
    mode: 'onSubmit',
  });

  const onSubmit = (data: FormInputs) => {
    onSubmitCallback(data.registrationNumber);
  };

  const formInputId = useId();
  const registrationNumberId = `${formInputId}-registrationNumber`;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Label htmlFor={registrationNumberId}>
        Enter Your Registration Number
      </Label>
      <Styled.Container>
        <Controller
          control={control}
          name="registrationNumber"
          rules={{
            required: {
              value: true,
              message: 'This field is required',
            },
          }}
          render={({ field, fieldState: { error } }) => {
            return (
              <RegistrationNumberField
                errorMessage={error?.message}
                id={registrationNumberId}
                {...field}
              />
            );
          }}
        />
        <Button
          ofType="TERTIARY"
          type="submit"
          data-tracking="cvonadp-get-my-free-valuation"
        >
          Get my free valuation
        </Button>
      </Styled.Container>
    </form>
  );
};

export { VehicleRegistrationLookupForm };
